import PropTypes from 'prop-types'
import { Component } from 'react'
import NumberFormat from 'react-number-format'

//must be kept as a class component since it may receive a ref from RHF's Controller - and function components can't receive refs?
//TODO maybe check at the RHF example if we can improve typing on this.... thing https://codesandbox.io/s/react-hook-form-normalize-field-forked-jhrq9?file=/src/index.js
export default class MoneyInput extends Component {
	render() {
		const { onChange, value, ...props } = this.props
		return <NumberFormat {...props}
		                     className="form-control"
		                     allowNegative={false}
		                     allowEmptyFormatting={false}
		                     fixedDecimalScale={true}
		                     maxLength={12}
		                     decimalScale={2}
		                     thousandSeparator=","
		                     prefix="$" //TODO this dollar sign (and maybe the separator above) will need to be internationalized at some point, but probably not with i18next since it won't depend on language, but on the restaurant location
		                     defaultValue={value} //without this, in some scenarios with a separate watcher over the field, the field would get frozen - probably because the field would be re-rendered and force changing its contents to the value prop again. Setting as defaultValue would solve this during re-renders. That said, using NumberFormat directly in place of MoneyInput doesn't cause the same issue? RBF...
		                     onValueChange={({ value }) => onChange(value)}
		/>
	}
}

MoneyInput.propTypes = {
	onChange: PropTypes.func.isRequired,
}
